import { SettlementOption } from "@covertree/new-business-graphql";

export function mapSettlementOptionToDisplayValue(
  settlementOption?: SettlementOption | null
): string {
  switch (settlementOption) {
    case SettlementOption.ActualCashValue:
      return "Actual Cash Value";
    case SettlementOption.ReplacementCost:
      return "Replacement Cost";
    case SettlementOption.ExtendedReplacementCost:
      return "Extended Replacement Cost";
    case SettlementOption.FullRepairCost:
      return "Full Repair Cost";
    default:
      return "Unknown";
  }
}
